import { environment } from '@environments/environment';
export const VERSION_API: any = 'api/v1.0/comercial/';
export const API_URL: any = environment.API_URL + VERSION_API;
